/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Col, Row } from "reactstrap";


export default function Landing() {
    return (
        <Row className="justify-content-center align-items-center" css={css`min-height: 300px`} >
            <Col className="text-center">
                <h1 className="mb-0 pt-4">Welcome to Admin Page</h1>
                <p className="mb-0 pt-2 pb-4">This is the landing page for admin.</p>
            </Col>
        </Row>
    );
}
